import React from "react";

const CardBody = React.forwardRef(function CardBody(
  { className = "", children, ...props },
  ref,
) {
  const classes = ["p-4", className].filter(Boolean).join(" ");

  return (
    <div ref={ref} className={classes} {...props}>
      {children}
    </div>
  );
});

export default CardBody;
